import { createMuiTheme } from "@material-ui/core/styles";

import purple from "@material-ui/core/colors/purple";
import green from "@material-ui/core/colors/green";

const theme = createMuiTheme({
    palette: {
        primary: purple,
        secondary: green,
        success: "#52a850",
        error: { main: "#74CADF" },
    },
    typography: {
        useNextVariants: true,
    },
    overrides: {
        MuiBox: {
            root: {
                marginTop: "10px",
                marginBottom: "10px",
            },
        },
    },
});
export default theme;
